import React from "react";
import themePropTypes from "../theme-prop-types";

const Address = ({
  variant,
  name,
  address_line1,
  city,
  state,
  zipCode,
  distance,
  onClick,
  settings
}) => (
  <button
    type='button'
    className={`address-web-sdk ${variant}`}
    onClick={onClick}
  >
    <span className='address-container-web-sdk'>
      <span className='address-header-web-sdk'>
        <span className='address-name-web-sdk'>{name}</span>
        {distance && (
          <span
            className='address-distance-web-sdk'
            aria-label={`${distance} ${
              distance === "1.0"
                ? settings?.translations.mile
                : settings?.translations.miles
            }`}
          >
            {distance} mi
          </span>
        )}
      </span>
      <span className='address-line1-web-sdk'>{address_line1}</span>
      <span
        className='address-line2-web-sdk'
        aria-label={`${city}, ${
          settings?.translations[state] || state
        } ${zipCode}`}
      >
        {city},{state} {zipCode}
      </span>
    </span>
  </button>
);

Address.propTypes = themePropTypes.address;

export default Address;
